import { render, staticRenderFns } from "./mainwarehouse.vue?vue&type=template&id=2333dd0a&"
import script from "./mainwarehouse.vue?vue&type=script&lang=js&"
export * from "./mainwarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports